import axios from "@/utils/server.js"
// 获取格式模板列表
export const getFormatListSer = (datas) => axios.get("/template/format/list", { params: datas })
    //添加格式模板
export const saveFormatSer = (datas) => axios.post("/template/format", null, { params: datas })
    //删除格式模板
export const deleteFormatSer = (datas) => axios.delete("/template/format", { params: datas })
    //获取格式模板详情
export const getFormatSer = (datas) => axios.get("/template/format/details", { params: datas })
    //修改格式模板
export const editFormatSer = (datas) => axios.put("/template/format", null, { params: datas })